import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import RelativeLink from "../common/RelativeLink";
import * as types from "../../constants/ComponentConstants";
import TabNavIcon from "../common/TabNavIcon";
import { DocumentTab } from "../../constants/DomainConstants";

const TabNavItem = (props) => {
	const color = props.color ? props.color : "blue";
	const iconType = props.iconType ? props.iconType : DocumentTab.Aanvraag;
	const navItemClassName = {
		"c-anchor-nav__item": true,
		["item--" + color]: true,
		"c-anchor-nav__item--disabled": props.disabled
	};

	return (props.visible ? <div className={classnames(navItemClassName)}>
		{!props.disabled ? <RelativeLink to={props.to} className="ui-tab">
			<TabNavIcon type={iconType} color={color} /><p>{props.text}</p>
		</RelativeLink> :
			<span><TabNavIcon type={iconType} color={color} /><p>{props.text}</p></span>}
	</div> : null);
};

TabNavItem.propTypes = {
	text: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	color: PropTypes.string,
	iconType: PropTypes.string,
	disabled: PropTypes.bool,
	visible: PropTypes.bool
};

export default TabNavItem;
